import React, { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { ChatProjectsPage } from "./chat/ChatProjectsPage";
import { ChatProjectView } from "./chat/ChatProjectView";

export const ChatInterface = () => {
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setIsAuthenticated(!!user);
    };
    checkAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session?.user);
      if (!session?.user) {
        setSelectedProjectId(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col items-center justify-center h-[600px] p-8 text-center bg-card rounded-xl border border-border">
        <p className="text-lg text-muted-foreground mb-2">Sign in to use AI Chat</p>
        <p className="text-sm text-muted-foreground">Create projects with custom instructions, memory, and files</p>
      </div>
    );
  }

  if (selectedProjectId) {
    return (
      <div className="h-[600px] bg-card rounded-xl border border-border overflow-hidden">
        <ChatProjectView
          projectId={selectedProjectId}
          onBack={() => setSelectedProjectId(null)}
        />
      </div>
    );
  }

  return (
    <div className="h-[600px] bg-card rounded-xl border border-border overflow-hidden">
      <ChatProjectsPage onSelectProject={setSelectedProjectId} />
    </div>
  );
};
